var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"login-bg"},[_c('v-container',{staticClass:"fill-height"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }